import { doKeyInc } from '../utils/map';
import { ParsedDecodedHeaders } from './parseAndDecodeHeaders.types';
import { HeaderParams, ParsedHeaderValue } from './parseHeaderValueAndParams.types';

export function getSingleHeader(
	headers: ParsedDecodedHeaders | undefined,
	key: string,
	multipleBehavior: 'throw' | 'use-last' | 'ignore' = 'use-last'
): ParsedHeaderValue | undefined {
	if (headers) {
		const vals = headers[key];
		if (vals && vals.length) {
			if (vals.length === 1) {
				return vals[0];
			} else if (multipleBehavior === 'throw') {
				throw new Error(`Got multiple headers with name ${key}`);
			} else if (multipleBehavior === 'use-last') {
				return vals[vals.length - 1];
			}
		}
	}
}

export function getSingleHeaderValue(
	headers: ParsedDecodedHeaders | undefined,
	key: string,
	multipleBehavior: 'throw' | 'use-last' | 'ignore' = 'use-last'
): string | undefined {
	const header = getSingleHeader(headers, key, multipleBehavior);
	if (header && header.value) {
		return header.value;
	}
}

export function paramsToString(params: HeaderParams | undefined): string {
	const items: string[] = [];

	if (params) {
		for (const key of Object.keys(params)) {
			if (key !== 'boundary') {
				items.push(`${key}: ${params[key]}`);
			}
		}
	}

	return items.join(', ');
}

export function headerToString(header: ParsedHeaderValue): string {
	const items: string[] = [header.value];

	const params = paramsToString(header.params);
	if (params) {
		items.push(params);
	}

	return items.join(', ');
}

export function aggSpecialChars(str: string): Map<number, number> {
	const specials: Map<number, number> = new Map();
	for (const char of str) {
		const cp = char.codePointAt(0)!;
		if (cp === 9 || cp === 10 || cp === 13 || (cp > 0x1f && cp < 0x7f)) {
			// Normal printable ASCII
		} else {
			doKeyInc(specials, cp);
		}
	}

	return specials;
}
